import { render, staticRenderFns } from "./NewExpenseCategoryModal.vue?vue&type=template&id=3b8c3da1&scoped=true&"
import script from "./NewExpenseCategoryModal.vue?vue&type=script&lang=js&"
export * from "./NewExpenseCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./NewExpenseCategoryModal.vue?vue&type=style&index=0&id=3b8c3da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c3da1",
  null
  
)

export default component.exports